// Library display helpers: validity windows, language names, licence labels, priority tone and the extraction-status dot colours shared by the tree and tables.
import type { ExtractionStatus, LicenceClass } from "@/api/__generated__";
import { formatDate } from "@/lib/format";

const languageNames = new Intl.DisplayNames(["en-GB"], { type: "language" });

export function validity(validFrom: string | null, validTo: string | null): string {
  if (validFrom === null && validTo === null) {
    return "Not set";
  }
  if (validTo === null) {
    return `Since ${formatDate(validFrom)}`;
  }
  if (validFrom === null) {
    return `Until ${formatDate(validTo)}`;
  }
  return `${formatDate(validFrom)} – ${formatDate(validTo)}`;
}

export function languageName(code: string): string {
  try {
    return languageNames.of(code) ?? code;
  } catch {
    return code;
  }
}

export const LICENCE_LABELS: Record<LicenceClass, string> = {
  public: "Public",
  licensed: "Licensed",
  confidential: "Confidential",
};

export const STATUS_DOT: Record<ExtractionStatus, string> = {
  extracted: "bg-brand-blue",
  reused: "bg-brand-blue",
  informative: "bg-b3",
  pending: "bg-stack-other",
  failed: "bg-brand-red",
  not_in_scope: "bg-border",
};

export function pageRange(start: number, end: number): string {
  return start === end ? `p. ${String(start)}` : `pp. ${String(start)}–${String(end)}`;
}
